import {
  updateAuthState,
  updateSwitchedUserDetails,
  updateUserDetail,
  updateUserSpecificDetail,
  updateUserPreferences,
} from "../redux/reducers/authSlice";
import {store} from "../redux/store";
import {decrypt} from "../commonUtils/crypto";
import {setHeader, postRequest} from "repository/genericRepository";
import {USERPROFILE_ENDPOINT} from "./globalAPISettings";
import {isValidObject, loggedMessage} from "./utils";
import {AxiosErrorCode, HttpStatusCode, PageNames} from "./enumerations";
import {
  HttpException,
  ServiceAuthenticationException,
} from "services/exceptionHandlerService";

export const decryptParameters = (urlParams: any) => {
  let token = "";
  let userIdentity = "";
  let userId = 0;
  let profileId = 0;
  let userName = "";
  let switchedUserId = 0;
  let switchedProfileId = 0;
  let switchedUserName = "";
  let llyReadOnlyUser = false;
  let supplierId = 0;
  let userTypeId = 0;
  let roles = "";
  if (
    urlParams.has("userIdentity") &&
    urlParams.has("userId") &&
    urlParams.has("profileId") &&
    urlParams.has("userName") &&
    urlParams.has("switchedUserId") &&
    urlParams.has("switchedProfileId") &&
    urlParams.has("switchedUserName") &&
    urlParams.has("token")
  ) {
    const encryptedUserIdentity = urlParams.get("userIdentity");
    const encryptedUserId = urlParams.get("userId");
    const encryptedProfileId = urlParams.get("profileId");
    const encryptedUserName = urlParams.get("userName");
    const encryptedSwitchedUserId = urlParams.get("switchedUserId");
    const encryptedSwitchedProfileId = urlParams.get("switchedProfileId");
    const encryptedSwitchedUserName = urlParams.get("switchedUserName");
    token = urlParams.get("token").replace(/ /g, "+");
    userIdentity = decrypt(encryptedUserIdentity.replace(/ /g, "+"));
    userId = Number(decrypt(encryptedUserId.replace(/ /g, "+")));
    profileId = Number(decrypt(encryptedProfileId.replace(/ /g, "+")));
    userName = decrypt(encryptedUserName.replace(/ /g, "+"));
    switchedUserId = Number(
      decrypt(encryptedSwitchedUserId.replace(/ /g, "+")),
    );
    switchedProfileId = Number(
      decrypt(encryptedSwitchedProfileId.replace(/ /g, "+")),
    );
    switchedUserName = decrypt(encryptedSwitchedUserName.replace(/ /g, "+"));
  }
  if (
    urlParams.has("llyReadOnlyUser") &&
    urlParams.has("supplierId") &&
    urlParams.has("userTypeId") &&
    urlParams.has("roles")
  ) {
    const encryptedLLYReadOnlyUser = urlParams.get("llyReadOnlyUser");
    const encryptedSupplierId = urlParams.get("supplierId");
    const encryptedUserTypeId = urlParams.get("userTypeId");
    const encryptedRoles = urlParams.get("roles");
    llyReadOnlyUser =
      decrypt(encryptedLLYReadOnlyUser.replace(/ /g, "+")).toLowerCase?.() ===
      "true";
    supplierId = Number(decrypt(encryptedSupplierId.replace(/ /g, "+")));
    userTypeId = Number(decrypt(encryptedUserTypeId.replace(/ /g, "+")));
    roles = decrypt(encryptedRoles.replace(/ /g, "+"));
  }
  return {
    token,
    userIdentity,
    userId,
    profileId,
    userName,
    switchedUserId,
    switchedProfileId,
    switchedUserName,
    llyReadOnlyUser,
    supplierId,
    userTypeId,
    roles,
  };
};

export const switchApplication = async (searchParams: any, path: any) => {
  if (searchParams !== "") {
    const parameters = new URLSearchParams(searchParams);
    const details = decryptParameters(parameters);
    const payLoadAuthState = {
      isAuthenticated: true,
      token: details.token,
    };
    const payLoadSwitchedUserDetails = {
      userIdentity: details.userIdentity,
      userId: details.userId,
      profileId: details.profileId,
      userName: details.userName,
      switchedUserId: details.switchedUserId,
      switchedProfileId: details.switchedProfileId,
      switchedUserName: details.switchedUserName,
    };
    const unsubscribe = store.subscribe(() => {});
    store.dispatch(updateAuthState(payLoadAuthState));
    store.dispatch(updateSwitchedUserDetails(payLoadSwitchedUserDetails));
    if (details.supplierId > 0) {
      const payLoadUserSpecificDetails = {
        llyReadOnlyUser: details.llyReadOnlyUser,
        supplierId: details.supplierId,
        userTypeId: details.userTypeId,
        roles: details.roles,
      };
      store.dispatch(updateUserSpecificDetail(payLoadUserSpecificDetails));
    }
    unsubscribe();
    await getMenus();
  }
};

const getMenus = async () => {
  try {
    const authState = store.getState();
    const APIHeaders = {
      Authorization: `Bearer ${authState.auth?.authDetails?.token}`,
    };
    const responseData = await postRequest({
      url:
        USERPROFILE_ENDPOINT +
        "?profileId=" +
        authState.auth?.userDetails?.profileId,
      headers: setHeader(APIHeaders),
      data: {},
    });
    if (isValidObject(responseData)) {
      const unsubscribe = store.subscribe(() => {});
      store.dispatch(updateUserPreferences(responseData?.userPreferences));
      store.dispatch(updateUserDetail(responseData?.userDetails));
      unsubscribe();
    }
  } catch (error: any) {
    loggedMessage(error, "", PageNames.SWITCHAPPLICATION);
    handleAxiosErrors(error);
  }
};

const handleAxiosErrors = (error: any) => {
  const data = {pagename: PageNames.SWITCHAPPLICATION};
  if (error?.code === AxiosErrorCode.ERR_BAD_REQUEST) {
    if (
      error?.response?.status === HttpStatusCode.UNAUTHORIZED ||
      error?.response?.status === HttpStatusCode.FORBIDDEN
    ) {
      ServiceAuthenticationException(error, data, error?.response?.status);
    } else if (error?.response?.status === HttpStatusCode.BAD_REQUEST) {
      // setErrorMsg(error.response.data.message);
    } else if (error?.response?.status === HttpStatusCode.NOT_FOUND) {
      // setErrorMsg(CPSConstants.SERVICE_NOT_FOUND);
    } else if (
      error?.response?.status === HttpStatusCode.INTERNAL_SERVER_ERROR
    ) {
      HttpException(error, data);
      // setErrorMsg(CPSConstants.INTERNAL_SERVER_ERROR);
    } else {
      // setErrorMsg(error.message);
    }
  } else if (error?.code === AxiosErrorCode.ECONNABORTED) {
    // setErrorMsg(CPSConstants.TIMEOUT_ERROR);
  } else if (error?.code === AxiosErrorCode.ERR_NETWORK) {
    // setErrorMsg(CPSConstants.NETWORK_ERROR);
  } else {
    // setErrorMsg(error.message);
  }
};
